import { cn } from '@theprintbar/shared';
import ReactSlider, { ReactSliderProps } from 'react-slider';

export function Slider<T extends number | number[]>(props: ReactSliderProps<T>) {
	return (
		<ReactSlider
			className={cn('w-full h-3 absolute left-0 rounded-full flex items-center', props.disabled && 'pointer-events-none opacity-50')}
			thumbClassName="w-4 h-4 rounded bg-blue absolute"
			trackClassName="bg-transparent h-3 rounded-full"
			renderThumb={({ children, ...props }) => <div {...props} />}
			pearling
			renderTrack={({ children, ...divProps }, state) => {
				return typeof props.value === 'number' || state.index === 1 ? (
					<div {...divProps} className="bg-blue-bright h-3 rounded-full absolute left-0" />
				) : null;
			}}
			{...props}
		/>
	);
}
